// @flow
import {camelCase as camelCaseObject} from 'change-case-object'
import {createFetchClientWithAuth} from '../util/request/middleware'
import type {ClientNotification, Preferences, PersonalPreferencesDTO, NotificationMethod} from '../definitions/swagger'

const client = createFetchClientWithAuth('v1/preferences')

/**
 * Update personal preferences
 * @link http://developmentmybudgetapi.azurewebsites.net/swagger/ui/index#!/Preferences/Preferences_UpdatePersonalPreferences
 * @param preferredName
 * @param email
 * @param mobileNumber
 * @returns {Promise<number>|Promise.<number>}
 */
export async function updatePersonalPreferences(preferredName : string, email : string, mobileNumber : string) : Promise<string>{
	const result : ClientNotification = await client.post('/personal', {
		body: {
			PreferredName: preferredName,
			Email: email,
			MobileNumber: mobileNumber
		}
	})

	return result.ClientNotificationId
}

export async function getUserInfo() : PersonalPreferencesDTO{
	const response = await client.get('', {query: {filter: "PersonalDetails"}})
	return camelCaseObject(response.PersonalDetails)
}

/**
 * Fetches the users preferences
 * @url https://developmentmybudgetapi.azurewebsites.net/swagger/ui/index#!/Preferences/NotificationPreferences_SetNotificationPreferences
 * @param filter
 * @returns {Promise<Object>}
 */
export async function getPreferences(filter : Array<string> = []) : Promise<Preferences>{
	return camelCaseObject(await client.get('', !filter.length ? {} : {
		query: {
			filter
		}
	}))
}

/**
 * Sets the communication preference
 * @url https://developmentmybudgetapi.azurewebsites.net/swagger/ui/index#!/Preferences/NotificationPreferences_SetAllNotificationPreferences
 * @param type
 * @param method
 * @returns {Promise.<string|*|number>}
 */
export async function setCommunicationPreference(type : $Keys<Preferences>, method : $Keys<NotificationMethod>) : Promise<string>{
	const result = await client.post(`/notification/${type.charAt(0).toUpperCase() + type.slice(1)}`, {
		body: {
			"Push": method === 'push',
			"SMS": method === 'sms',
			"WebMessage": method === 'webMessage',
			"Email": method === 'email'
		}
	})

	return result.ClientNotificationId
}



// WEBPACK FOOTER //
// ./node_modules/mb-app-common/lib/api/preferences.js